import { positionSorter } from '~/utils/filters/filters'

export function metadataOccasionsToFilters(
  occasionKey,
  occasions,
  occasionSlugs,
) {
  const category = occasions.find((x) => x.key === occasionKey)
  if (!category || !occasionSlugs) return []
  return category.items
    .filter((item) => occasionSlugs.includes(item.slug))
    .map((item) => ({
      category: 'occasions',
      key: item.slug,
      name: item.name,
      position: item.position,
    }))
    .sort(positionSorter)
}
